import { render } from "./pre-sign-in.vue?vue&type=template&id=56207996&scoped=true"
import script from "./pre-sign-in.vue?vue&type=script&lang=js"
export * from "./pre-sign-in.vue?vue&type=script&lang=js"

import "./pre-sign-in.vue?vue&type=style&index=0&id=56207996&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56207996"]])

export default __exports__